module.exports = __webpack_public_path__ + "static/media/BNT.b016f318.svg";